import { render } from "./MedicationPagination.vue?vue&type=template&id=6f3aa4b4&scoped=true"
import script from "./MedicationPagination.vue?vue&type=script&lang=js"
export * from "./MedicationPagination.vue?vue&type=script&lang=js"

import "./MedicationPagination.vue?vue&type=style&index=0&id=6f3aa4b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3aa4b4"]])

export default __exports__